import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { ActivityFeed } from "@/components/activity-feed";
import { DashboardChart } from "@/components/dashboard-chart";
import { SectionCards } from "@/components/section-cards";
import { api } from "@/lib/convex-api";

export const Route = createFileRoute("/_authenticated/")({
	component: DashboardHome,
});

function DashboardHome() {
	const stats = useQuery(api.admin.getDashboardStats);
	const activity = useQuery(api.admin.getRecentActivity, { limit: 15 });

	return (
		<div className="flex flex-1 flex-col">
			<div className="@container/main flex flex-1 flex-col gap-2">
				<div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6">
					<SectionCards stats={stats} />
					<div className="px-4 lg:px-6">
						<DashboardChart />
					</div>
					<div className="px-4 lg:px-6">
						<ActivityFeed activity={activity} />
					</div>
				</div>
			</div>
		</div>
	);
}
